(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["esc-custom-order-form"] && !Shopify.designMode) return;
  try {
    
  const customOrderForm = document.getElementById('CustomOrderForm');

  if (customOrderForm) {
    const cakes = customOrderForm.querySelector('[data-cakes]');
    const addCakeButton = customOrderForm.querySelector('[data-add-cake]');

    if (cakes && addCakeButton) {
      addCakeButton.addEventListener('click', () => {
        const currentCakes = cakes.querySelectorAll('[data-cake]');
        const nextIndex = currentCakes.length + 1;
        const clone = currentCakes[0].cloneNode(true);

        clone.querySelector('[data-cake-number]').textContent = nextIndex;

        clone.querySelectorAll('input, select, textarea').forEach((field) => {
          if (field.name) {
            field.name = field.name.replace('cake_1_', `cake_${nextIndex}_`);
          }

          if (field.type === 'radio' || field.type === 'checkbox') {
            field.checked = false;
          } else if (field.tagName === 'SELECT') {
            field.selectedIndex = 0;
          } else {
            field.value = '';
          }
        });

        cakes.appendChild(clone);
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
